import { __ } from '@wordpress/i18n';

// Extracted from <https://gitlab.com/inkscape/inkscape/-/blob/master/share/palettes/inkscape.gpl>

export const baseColors = [
	{ color: 'rgb(0, 0, 0)', label: __( 'Black', 'jeo' ) },
	{ color: 'rgb(26, 26, 26)', label: __( '90% Gray', 'jeo' ) },
	{ color: 'rgb(51, 51, 51)', label: __( '80% Gray', 'jeo' ) },
	{ color: 'rgb(77, 77, 77)', label: __( '70% Gray', 'jeo' ) },
	{ color: 'rgb(102, 102, 102)', label: __( '60% Gray', 'jeo' ) },
	{ color: 'rgb(128, 128, 128)', label: __( '50% Gray', 'jeo' ) },
	{ color: 'rgb(153, 153, 153)', label: __( '40% Gray', 'jeo' ) },
	{ color: 'rgb(179, 179, 179)', label: __( '30% Gray', 'jeo' ) },
	{ color: 'rgb(204, 204, 204)', label: __( '20% Gray', 'jeo' ) },
	{ color: 'rgb(230, 230, 230)', label: __( '10% Gray', 'jeo' ) },
	{ color: 'rgb(236, 236, 236)', label: __( '7.5% Gray', 'jeo' ) },
	{ color: 'rgb(242, 242, 242)', label: __( '5% Gray', 'jeo' ) },
	{ color: 'rgb(249, 249, 249)', label: __( '2.5% Gray', 'jeo' ) },
	{ color: 'rgb(255, 255, 255)', label: __( 'White', 'jeo' ) },
	{ color: 'rgb(128, 0, 0)', label: __( 'Maroon', 'jeo' ) },
	{ color: 'rgb(255, 0, 0)', label: __( 'Red', 'jeo' ) },
	{ color: 'rgb(128, 128, 0)', label: __( 'Olive', 'jeo' ) },
	{ color: 'rgb(255, 255, 0)', label: __( 'Yellow', 'jeo' ) },
	{ color: 'rgb(0, 128, 0)', label: __( 'Green', 'jeo' ) },
	{ color: 'rgb(0, 255, 0)', label: __( 'Lime', 'jeo' ) },
	{ color: 'rgb(0, 128, 128)', label: __( 'Teal', 'jeo' ) },
	{ color: 'rgb(0, 255, 255)', label: __( 'Aqua', 'jeo' ) },
	{ color: 'rgb(0, 0, 128)', label: __( 'Navy', 'jeo' ) },
	{ color: 'rgb(0, 0, 255)', label: __( 'Blue', 'jeo' ) },
	{ color: 'rgb(128, 0, 128)', label: __( 'Purple', 'jeo' ) },
	{ color: 'rgb(255, 0, 255)', label: __( 'Fuchsia', 'jeo' ) },
	{ color: 'rgb(43, 0, 0)' },
	{ color: 'rgb(85, 0, 0)' },
	{ color: 'rgb(128, 0, 0)' },
	{ color: 'rgb(170, 0, 0)' },
	{ color: 'rgb(212, 0, 0)' },
	{ color: 'rgb(255, 0, 0)' },
	{ color: 'rgb(255, 42, 42)' },
	{ color: 'rgb(255, 85, 85)' },
	{ color: 'rgb(255, 128, 128)' },
	{ color: 'rgb(255, 170, 170)' },
	{ color: 'rgb(255, 213, 213)' },
	{ color: 'rgb(40, 11, 11)' },
	{ color: 'rgb(80, 22, 22)' },
	{ color: 'rgb(120, 33, 33)' },
	{ color: 'rgb(160, 44, 44)' },
	{ color: 'rgb(200, 55, 55)' },
	{ color: 'rgb(211, 95, 95)' },
	{ color: 'rgb(222, 135, 135)' },
	{ color: 'rgb(233, 175, 175)' },
	{ color: 'rgb(244, 215, 215)' },
	{ color: 'rgb(36, 28, 28)' },
	{ color: 'rgb(72, 55, 55)' },
	{ color: 'rgb(108, 83, 83)' },
	{ color: 'rgb(145, 111, 111)' },
	{ color: 'rgb(172, 147, 147)' },
	{ color: 'rgb(200, 183, 183)' },
	{ color: 'rgb(227, 219, 219)' },
	{ color: 'rgb(43, 17, 0)' },
	{ color: 'rgb(85, 34, 0)' },
	{ color: 'rgb(128, 51, 0)' },
	{ color: 'rgb(170, 68, 0)' },
	{ color: 'rgb(212, 85, 0)' },
	{ color: 'rgb(255, 102, 0)' },
	{ color: 'rgb(255, 127, 42)' },
	{ color: 'rgb(255, 153, 85)' },
	{ color: 'rgb(255, 179, 128)' },
	{ color: 'rgb(255, 204, 170)' },
	{ color: 'rgb(255, 230, 213)' },
	{ color: 'rgb(40, 23, 11)' },
	{ color: 'rgb(80, 45, 22)' },
	{ color: 'rgb(120, 68, 33)' },
	{ color: 'rgb(160, 90, 44)' },
	{ color: 'rgb(200, 113, 55)' },
	{ color: 'rgb(211, 141, 95)' },
	{ color: 'rgb(222, 170, 135)' },
	{ color: 'rgb(233, 198, 175)' },
	{ color: 'rgb(244, 227, 215)' },
	{ color: 'rgb(36, 31, 28)' },
	{ color: 'rgb(72, 62, 55)' },
	{ color: 'rgb(108, 93, 83)' },
	{ color: 'rgb(145, 124, 111)' },
	{ color: 'rgb(172, 157, 147)' },
	{ color: 'rgb(200, 190, 183)' },
	{ color: 'rgb(227, 222, 219)' },
	{ color: 'rgb(43, 34, 0)' },
	{ color: 'rgb(85, 68, 0)' },
	{ color: 'rgb(128, 102, 0)' },
	{ color: 'rgb(170, 136, 0)' },
	{ color: 'rgb(212, 170, 0)' },
	{ color: 'rgb(255, 204, 0)' },
	{ color: 'rgb(255, 212, 42)' },
	{ color: 'rgb(255, 221, 85)' },
	{ color: 'rgb(255, 230, 128)' },
	{ color: 'rgb(255, 238, 170)' },
	{ color: 'rgb(255, 246, 213)' },
	{ color: 'rgb(40, 34, 11)' },
	{ color: 'rgb(80, 68, 22)' },
	{ color: 'rgb(120, 103, 33)' },
	{ color: 'rgb(160, 137, 44)' },
	{ color: 'rgb(200, 171, 55)' },
	{ color: 'rgb(211, 188, 95)' },
	{ color: 'rgb(222, 205, 135)' },
	{ color: 'rgb(233, 221, 175)' },
	{ color: 'rgb(244, 238, 215)' },
	{ color: 'rgb(36, 34, 28)' },
	{ color: 'rgb(72, 69, 55)' },
	{ color: 'rgb(108, 103, 83)' },
	{ color: 'rgb(145, 138, 111)' },
	{ color: 'rgb(172, 167, 147)' },
	{ color: 'rgb(200, 196, 183)' },
	{ color: 'rgb(227, 226, 219)' },
	{ color: 'rgb(34, 43, 0)' },
	{ color: 'rgb(68, 85, 0)' },
	{ color: 'rgb(102, 128, 0)' },
	{ color: 'rgb(136, 170, 0)' },
	{ color: 'rgb(170, 212, 0)' },
	{ color: 'rgb(204, 255, 0)' },
	{ color: 'rgb(212, 255, 42)' },
	{ color: 'rgb(221, 255, 85)' },
	{ color: 'rgb(229, 255, 128)' },
	{ color: 'rgb(238, 255, 170)' },
	{ color: 'rgb(246, 255, 213)' },
	{ color: 'rgb(34, 40, 11)' },
	{ color: 'rgb(68, 80, 22)' },
	{ color: 'rgb(103, 120, 33)' },
	{ color: 'rgb(137, 160, 44)' },
	{ color: 'rgb(171, 200, 55)' },
	{ color: 'rgb(188, 211, 95)' },
	{ color: 'rgb(205, 222, 135)' },
	{ color: 'rgb(221, 233, 175)' },
	{ color: 'rgb(238, 244, 215)' },
	{ color: 'rgb(34, 36, 28)' },
	{ color: 'rgb(69, 72, 55)' },
	{ color: 'rgb(103, 108, 83)' },
	{ color: 'rgb(138, 145, 111)' },
	{ color: 'rgb(167, 172, 147)' },
	{ color: 'rgb(196, 200, 183)' },
	{ color: 'rgb(226, 227, 219)' },
	{ color: 'rgb(17, 43, 0)' },
	{ color: 'rgb(34, 85, 0)' },
	{ color: 'rgb(51, 128, 0)' },
	{ color: 'rgb(68, 170, 0)' },
	{ color: 'rgb(85, 212, 0)' },
	{ color: 'rgb(102, 255, 0)' },
	{ color: 'rgb(127, 255, 42)' },
	{ color: 'rgb(153, 255, 85)' },
	{ color: 'rgb(179, 255, 128)' },
	{ color: 'rgb(204, 255, 170)' },
	{ color: 'rgb(229, 255, 213)' },
	{ color: 'rgb(23, 40, 11)' },
	{ color: 'rgb(45, 80, 22)' },
	{ color: 'rgb(68, 120, 33)' },
	{ color: 'rgb(90, 160, 44)' },
	{ color: 'rgb(113, 200, 55)' },
	{ color: 'rgb(141, 211, 95)' },
	{ color: 'rgb(170, 222, 135)' },
	{ color: 'rgb(198, 233, 175)' },
	{ color: 'rgb(227, 244, 215)' },
	{ color: 'rgb(31, 36, 28)' },
	{ color: 'rgb(62, 72, 55)' },
	{ color: 'rgb(93, 108, 83)' },
	{ color: 'rgb(124, 145, 111)' },
	{ color: 'rgb(157, 172, 147)' },
	{ color: 'rgb(190, 200, 183)' },
	{ color: 'rgb(222, 227, 219)' },
	{ color: 'rgb(0, 43, 0)' },
	{ color: 'rgb(0, 85, 0)' },
	{ color: 'rgb(0, 128, 0)' },
	{ color: 'rgb(0, 170, 0)' },
	{ color: 'rgb(0, 212, 0)' },
	{ color: 'rgb(0, 255, 0)' },
	{ color: 'rgb(42, 255, 42)' },
	{ color: 'rgb(85, 255, 85)' },
	{ color: 'rgb(128, 255, 128)' },
	{ color: 'rgb(170, 255, 170)' },
	{ color: 'rgb(213, 255, 213)' },
	{ color: 'rgb(11, 40, 11)' },
	{ color: 'rgb(22, 80, 22)' },
	{ color: 'rgb(33, 120, 33)' },
	{ color: 'rgb(44, 160, 44)' },
	{ color: 'rgb(55, 200, 55)' },
	{ color: 'rgb(95, 211, 95)' },
	{ color: 'rgb(135, 222, 135)' },
	{ color: 'rgb(175, 233, 175)' },
	{ color: 'rgb(215, 244, 215)' },
	{ color: 'rgb(28, 36, 28)' },
	{ color: 'rgb(55, 72, 55)' },
	{ color: 'rgb(83, 108, 83)' },
	{ color: 'rgb(111, 145, 111)' },
	{ color: 'rgb(147, 172, 147)' },
	{ color: 'rgb(183, 200, 183)' },
	{ color: 'rgb(219, 227, 219)' },
	{ color: 'rgb(0, 43, 17)' },
	{ color: 'rgb(0, 85, 34)' },
	{ color: 'rgb(0, 128, 51)' },
	{ color: 'rgb(0, 170, 68)' },
	{ color: 'rgb(0, 212, 85)' },
	{ color: 'rgb(0, 255, 102)' },
	{ color: 'rgb(42, 255, 128)' },
	{ color: 'rgb(85, 255, 153)' },
	{ color: 'rgb(128, 255, 179)' },
	{ color: 'rgb(170, 255, 204)' },
	{ color: 'rgb(213, 255, 230)' },
	{ color: 'rgb(11, 40, 23)' },
	{ color: 'rgb(22, 80, 45)' },
	{ color: 'rgb(33, 120, 68)' },
	{ color: 'rgb(44, 160, 90)' },
	{ color: 'rgb(55, 200, 113)' },
	{ color: 'rgb(95, 211, 141)' },
	{ color: 'rgb(135, 222, 170)' },
	{ color: 'rgb(175, 233, 198)' },
	{ color: 'rgb(215, 244, 227)' },
	{ color: 'rgb(28, 36, 31)' },
	{ color: 'rgb(55, 72, 62)' },
	{ color: 'rgb(83, 108, 93)' },
	{ color: 'rgb(111, 145, 124)' },
	{ color: 'rgb(147, 172, 157)' },
	{ color: 'rgb(183, 200, 190)' },
	{ color: 'rgb(219, 227, 222)' },
	{ color: 'rgb(0, 43, 34)' },
	{ color: 'rgb(0, 85, 68)' },
	{ color: 'rgb(0, 128, 102)' },
	{ color: 'rgb(0, 170, 136)' },
	{ color: 'rgb(0, 212, 170)' },
	{ color: 'rgb(0, 255, 204)' },
	{ color: 'rgb(42, 255, 213)' },
	{ color: 'rgb(85, 255, 221)' },
	{ color: 'rgb(128, 255, 230)' },
	{ color: 'rgb(170, 255, 238)' },
	{ color: 'rgb(213, 255, 246)' },
	{ color: 'rgb(11, 40, 34)' },
	{ color: 'rgb(22, 80, 68)' },
	{ color: 'rgb(33, 120, 103)' },
	{ color: 'rgb(44, 160, 137)' },
	{ color: 'rgb(55, 200, 171)' },
	{ color: 'rgb(95, 211, 188)' },
	{ color: 'rgb(135, 222, 205)' },
	{ color: 'rgb(175, 233, 221)' },
	{ color: 'rgb(215, 244, 238)' },
	{ color: 'rgb(28, 36, 34)' },
	{ color: 'rgb(55, 72, 69)' },
	{ color: 'rgb(83, 108, 103)' },
	{ color: 'rgb(111, 145, 138)' },
	{ color: 'rgb(147, 172, 167)' },
	{ color: 'rgb(183, 200, 196)' },
	{ color: 'rgb(219, 227, 226)' },
	{ color: 'rgb(0, 34, 43)' },
	{ color: 'rgb(0, 68, 85)' },
	{ color: 'rgb(0, 102, 128)' },
	{ color: 'rgb(0, 136, 170)' },
	{ color: 'rgb(0, 170, 212)' },
	{ color: 'rgb(0, 204, 255)' },
	{ color: 'rgb(42, 212, 255)' },
	{ color: 'rgb(85, 221, 255)' },
	{ color: 'rgb(128, 229, 255)' },
	{ color: 'rgb(170, 238, 255)' },
	{ color: 'rgb(213, 246, 255)' },
	{ color: 'rgb(11, 34, 40)' },
	{ color: 'rgb(22, 68, 80)' },
	{ color: 'rgb(33, 103, 120)' },
	{ color: 'rgb(44, 137, 160)' },
	{ color: 'rgb(55, 171, 200)' },
	{ color: 'rgb(95, 188, 211)' },
	{ color: 'rgb(135, 205, 222)' },
	{ color: 'rgb(175, 221, 233)' },
	{ color: 'rgb(215, 238, 244)' },
	{ color: 'rgb(28, 34, 36)' },
	{ color: 'rgb(55, 69, 72)' },
	{ color: 'rgb(83, 103, 108)' },
	{ color: 'rgb(111, 138, 145)' },
	{ color: 'rgb(147, 167, 172)' },
	{ color: 'rgb(183, 196, 200)' },
	{ color: 'rgb(219, 226, 227)' },
	{ color: 'rgb(0, 17, 43)' },
	{ color: 'rgb(0, 34, 85)' },
	{ color: 'rgb(0, 51, 128)' },
	{ color: 'rgb(0, 68, 170)' },
	{ color: 'rgb(0, 85, 212)' },
	{ color: 'rgb(0, 102, 255)' },
	{ color: 'rgb(42, 127, 255)' },
	{ color: 'rgb(85, 153, 255)' },
	{ color: 'rgb(128, 179, 255)' },
	{ color: 'rgb(170, 204, 255)' },
	{ color: 'rgb(213, 229, 255)' },
	{ color: 'rgb(11, 23, 40)' },
	{ color: 'rgb(22, 45, 80)' },
	{ color: 'rgb(33, 68, 120)' },
	{ color: 'rgb(44, 90, 160)' },
	{ color: 'rgb(55, 113, 200)' },
	{ color: 'rgb(95, 141, 211)' },
	{ color: 'rgb(135, 170, 222)' },
	{ color: 'rgb(175, 198, 233)' },
	{ color: 'rgb(215, 227, 244)' },
	{ color: 'rgb(28, 31, 36)' },
	{ color: 'rgb(55, 62, 72)' },
	{ color: 'rgb(83, 93, 108)' },
	{ color: 'rgb(111, 124, 145)' },
	{ color: 'rgb(147, 157, 172)' },
	{ color: 'rgb(183, 190, 200)' },
	{ color: 'rgb(219, 222, 227)' },
	{ color: 'rgb(0, 0, 43)' },
	{ color: 'rgb(0, 0, 85)' },
	{ color: 'rgb(0, 0, 128)' },
	{ color: 'rgb(0, 0, 170)' },
	{ color: 'rgb(0, 0, 212)' },
	{ color: 'rgb(0, 0, 255)' },
	{ color: 'rgb(42, 42, 255)' },
	{ color: 'rgb(85, 85, 255)' },
	{ color: 'rgb(128, 128, 255)' },
	{ color: 'rgb(170, 170, 255)' },
	{ color: 'rgb(213, 213, 255)' },
	{ color: 'rgb(11, 11, 40)' },
	{ color: 'rgb(22, 22, 80)' },
	{ color: 'rgb(33, 33, 120)' },
	{ color: 'rgb(44, 44, 160)' },
	{ color: 'rgb(55, 55, 200)' },
	{ color: 'rgb(95, 95, 211)' },
	{ color: 'rgb(135, 135, 222)' },
	{ color: 'rgb(175, 175, 233)' },
	{ color: 'rgb(215, 215, 244)' },
	{ color: 'rgb(28, 28, 36)' },
	{ color: 'rgb(55, 55, 72)' },
	{ color: 'rgb(83, 83, 108)' },
	{ color: 'rgb(111, 111, 145)' },
	{ color: 'rgb(147, 147, 172)' },
	{ color: 'rgb(183, 183, 200)' },
	{ color: 'rgb(219, 219, 227)' },
	{ color: 'rgb(17, 0, 43)' },
	{ color: 'rgb(34, 0, 85)' },
	{ color: 'rgb(51, 0, 128)' },
	{ color: 'rgb(68, 0, 170)' },
	{ color: 'rgb(85, 0, 212)' },
	{ color: 'rgb(102, 0, 255)' },
	{ color: 'rgb(127, 42, 255)' },
	{ color: 'rgb(153, 85, 255)' },
	{ color: 'rgb(179, 128, 255)' },
	{ color: 'rgb(204, 170, 255)' },
	{ color: 'rgb(229, 213, 255)' },
	{ color: 'rgb(23, 11, 40)' },
	{ color: 'rgb(45, 22, 80)' },
	{ color: 'rgb(68, 33, 120)' },
	{ color: 'rgb(90, 44, 160)' },
	{ color: 'rgb(113, 55, 200)' },
	{ color: 'rgb(141, 95, 211)' },
	{ color: 'rgb(170, 135, 222)' },
	{ color: 'rgb(198, 175, 233)' },
	{ color: 'rgb(227, 215, 244)' },
	{ color: 'rgb(31, 28, 36)' },
	{ color: 'rgb(62, 55, 72)' },
	{ color: 'rgb(93, 83, 108)' },
	{ color: 'rgb(124, 111, 145)' },
	{ color: 'rgb(157, 147, 172)' },
	{ color: 'rgb(190, 183, 200)' },
	{ color: 'rgb(222, 219, 227)' },
	{ color: 'rgb(34, 0, 43)' },
	{ color: 'rgb(68, 0, 85)' },
	{ color: 'rgb(102, 0, 128)' },
	{ color: 'rgb(136, 0, 170)' },
	{ color: 'rgb(170, 0, 212)' },
	{ color: 'rgb(204, 0, 255)' },
	{ color: 'rgb(212, 42, 255)' },
	{ color: 'rgb(221, 85, 255)' },
	{ color: 'rgb(229, 128, 255)' },
	{ color: 'rgb(238, 170, 255)' },
	{ color: 'rgb(246, 213, 255)' },
	{ color: 'rgb(34, 11, 40)' },
	{ color: 'rgb(68, 22, 80)' },
	{ color: 'rgb(103, 33, 120)' },
	{ color: 'rgb(137, 44, 160)' },
	{ color: 'rgb(171, 55, 200)' },
	{ color: 'rgb(188, 95, 211)' },
	{ color: 'rgb(205, 135, 222)' },
	{ color: 'rgb(221, 175, 233)' },
	{ color: 'rgb(238, 215, 244)' },
	{ color: 'rgb(34, 28, 36)' },
	{ color: 'rgb(69, 55, 72)' },
	{ color: 'rgb(103, 83, 108)' },
	{ color: 'rgb(138, 111, 145)' },
	{ color: 'rgb(167, 147, 172)' },
	{ color: 'rgb(196, 183, 200)' },
	{ color: 'rgb(226, 219, 227)' },
	{ color: 'rgb(43, 0, 34)' },
	{ color: 'rgb(85, 0, 68)' },
	{ color: 'rgb(128, 0, 102)' },
	{ color: 'rgb(170, 0, 136)' },
	{ color: 'rgb(212, 0, 170)' },
	{ color: 'rgb(255, 0, 204)' },
	{ color: 'rgb(255, 42, 212)' },
	{ color: 'rgb(255, 85, 221)' },
	{ color: 'rgb(255, 128, 229)' },
	{ color: 'rgb(255, 170, 238)' },
	{ color: 'rgb(255, 213, 246)' },
	{ color: 'rgb(40, 11, 34)' },
	{ color: 'rgb(80, 22, 68)' },
	{ color: 'rgb(120, 33, 103)' },
	{ color: 'rgb(160, 44, 137)' },
	{ color: 'rgb(200, 55, 171)' },
	{ color: 'rgb(211, 95, 188)' },
	{ color: 'rgb(222, 135, 205)' },
	{ color: 'rgb(233, 175, 221)' },
	{ color: 'rgb(244, 215, 238)' },
	{ color: 'rgb(36, 28, 34)' },
	{ color: 'rgb(72, 55, 69)' },
	{ color: 'rgb(108, 83, 103)' },
	{ color: 'rgb(145, 111, 138)' },
	{ color: 'rgb(172, 147, 167)' },
	{ color: 'rgb(200, 183, 196)' },
	{ color: 'rgb(227, 219, 226)' },
	{ color: 'rgb(43, 0, 17)' },
	{ color: 'rgb(85, 0, 34)' },
	{ color: 'rgb(128, 0, 51)' },
	{ color: 'rgb(170, 0, 68)' },
	{ color: 'rgb(212, 0, 85)' },
	{ color: 'rgb(255, 0, 102)' },
	{ color: 'rgb(255, 42, 127)' },
	{ color: 'rgb(255, 85, 153)' },
	{ color: 'rgb(255, 128, 178)' },
	{ color: 'rgb(255, 170, 204)' },
	{ color: 'rgb(255, 213, 229)' },
	{ color: 'rgb(40, 11, 23)' },
	{ color: 'rgb(80, 22, 45)' },
	{ color: 'rgb(120, 33, 68)' },
	{ color: 'rgb(160, 44, 90)' },
	{ color: 'rgb(200, 55, 113)' },
	{ color: 'rgb(211, 95, 141)' },
	{ color: 'rgb(222, 135, 170)' },
	{ color: 'rgb(233, 175, 198)' },
	{ color: 'rgb(244, 215, 227)' },
	{ color: 'rgb(36, 28, 31)' },
	{ color: 'rgb(72, 55, 62)' },
	{ color: 'rgb(108, 83, 93)' },
	{ color: 'rgb(145, 111, 124)' },
	{ color: 'rgb(172, 147, 157)' },
	{ color: 'rgb(200, 183, 190)' },
	{ color: 'rgb(227, 219, 222)' },
]
